// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"393":"09173eca","878":"2ef8d279","898":"b7df5847","919":"64f1fed1"}[chunkId] + ".chunk.js";
};